'use client'

import { useState, useEffect } from 'react'
import { ChevronUpIcon } from '@heroicons/react/24/outline'

export function BackToTop() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }

        window.addEventListener('scroll', toggleVisibility)
        return () => window.removeEventListener('scroll', toggleVisibility)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    return (
        <button
            onClick={scrollToTop}
            className={`${isVisible ? 'opacity-70' : 'opacity-0'
                } fixed right-4 bottom-4 z-50 flex flex-col items-center text-gray-600 transition-all duration-300 hover:text-gray-900 md:hidden`}
            aria-label="Back to top"
        >
            <ChevronUpIcon className="h-5 w-5" />
            <span className="text-xs font-medium">Back Top</span>
        </button>
    )
} 